"use client";

import Link from "next/link";
import { useI18n } from "@/i18n";
import { useLangHref } from "@/i18n/useLangHref";

const buyLinks = [
    { labelKey: "footer.buy.all", href: "/search" },
    { labelKey: "footer.buy.cars", href: "/search?type=cars" },
    { labelKey: "footer.buy.bikes", href: "/search?type=bikes" },
    { labelKey: "footer.buy.trucks", href: "/search?type=trucks" },
    { labelKey: "footer.buy.parts", href: "/parts" },
];
const sellLinks = [
    { labelKey: "footer.sell.publish", href: "/publish" },
    { labelKey: "footer.sell.promote", href: "/promote" },
    { labelKey: "footer.sell.dealers", href: "/dealers" },
    { labelKey: "footer.sell.pricing", href: "/blog" },
];
const supportLinks = [
    { labelKey: "footer.support.helpCenter", href: "/help" },
    { labelKey: "footer.support.safeTrading", href: "/safety" },
    { labelKey: "footer.support.blog", href: "/blog" },
    { labelKey: "footer.support.contact", href: "/contact" },
];
// Contact info: phone/email/address are locale-agnostic, no translation needed
const contactLinks = [
    { label: "📞 +86-21-37788331", href: "tel:+862137788331" },
    { label: "✉️ 18918855336@126.com", href: "mailto:18918855336@126.com" },
    { label: "📍 Shanghai, China", href: "#" },
];

export default function Footer() {
    const { t } = useI18n();
    const langHref = useLangHref();
    const year = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-grid">
                    <div>
                        <Link href={langHref("/")} className="footer-brand">
                            <img src="/assets/logo-mark.svg" alt="GuineeMall" className="logo-mark-img" />
                            <span className="logo-text" style={{ color: "white" }}>GuineeMall</span>
                        </Link>
                        <p className="footer-desc">{t("footer.aboutText")}</p>
                    </div>
                    <div>
                        <div className="footer-title">{t("footer.buyTitle")}</div>
                        <ul>
                            {buyLinks.map((link) => (
                                <li key={link.labelKey}>
                                    <Link href={langHref(link.href)}>{t(link.labelKey)}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <div className="footer-title">{t("footer.sellTitle")}</div>
                        <ul>
                            {sellLinks.map((link) => (
                                <li key={link.labelKey}>
                                    <Link href={langHref(link.href)}>{t(link.labelKey)}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <div className="footer-title">{t("footer.supportTitle")}</div>
                        <ul>
                            {supportLinks.map((link) => (
                                <li key={link.labelKey}>
                                    <Link href={langHref(link.href)}>{t(link.labelKey)}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <div className="footer-title">{t("footer.contactTitle")}</div>
                        <ul>
                            {contactLinks.map((link) => (
                                <li key={link.label}>
                                    <Link href={langHref(link.href)}>{link.label}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div>{t("footer.copyright", { year })}</div>
                    <div className="flex gap-4">
                        <Link href={langHref("/privacy")}>{t("footer.legal.privacy")}</Link>
                        <Link href={langHref("/terms")}>{t("footer.legal.terms")}</Link>
                        <Link href={langHref("/cookies")}>{t("footer.legal.cookies")}</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
